import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import {ThemeService, AuthService} from '../../providers/index';

/*
  Generated class for the Signup page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-signup',
  templateUrl: 'signup.html'
})
export class SignupPage {


  public project: string; //TODO
  public name: string;

  constructor(public navCtrl: NavController,
              private _theme: ThemeService, private _auth: AuthService) {
    this.project = this._theme.getSlogan();

  }

  signup(userEmail,userPassword): void {
    console.log('signing up with local credentials');
    this._auth.signUp(userEmail,userPassword).then(() => this.onSignInSuccess());
    //TODO: Confirm we're also signed in
  }

  private onSignInSuccess(): void {
    console.log("Display name ",this._auth.displayName());
    console.log("Display email ",this._auth.displayEmail());
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SignupPage');
  }

  // Only go here if we need to
  ionViewCanEnter(): boolean {
    if(this._auth.authenticated){
      console.log('Already Authenticated so you cannot see this page: ');
      return false;
    } else {
      console.log('not signed up so you can see this page: '); //TODO: Add reference to page
      return true;
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/signup/signup.ts